import React, { useState, useEffect } from 'react';
import { getUsers } from '../data/supabaseApi';
import { FiUser } from 'react-icons/fi';
import './Topbar.css';

const Topbar = ({ userName, userRole, onUserChange }) => {
  const [selectedUserName, setSelectedUserName] = useState(userName || '');
  const [users, setUsers] = useState([]);
  const [showUserSelector, setShowUserSelector] = useState(false);

  // Run once on mount: load users and set initial selected user (do not depend on onUserChange to avoid infinite loop)
  useEffect(() => {
    let cancelled = false;
    getUsers().then((allUsers) => {
      if (cancelled) return;
      setUsers(allUsers);
      if (userRole === 'member') {
        setSelectedUserName('');
        localStorage.setItem('selectedUserName', '');
        if (onUserChange) onUserChange('');
      }
      // Admin: no user selector, always sees all members' tasks — nothing to set
    });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedUserName(userName || '');
  }, [userName]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showUserSelector && !event.target.closest('.user-selector-container')) {
        setShowUserSelector(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showUserSelector]);

  const handleUserChange = (newUserName) => {
    const value = newUserName || '';
    setSelectedUserName(value);
    localStorage.setItem('selectedUserName', value);
    if (onUserChange) onUserChange(value);
    setShowUserSelector(false);
    window.dispatchEvent(new Event('storage'));
    window.dispatchEvent(new CustomEvent('userNameChanged', { detail: value }));
  };

  return (
    <div className="topbar">
      <div className="topbar-content">
        <h1 className="topbar-title">
          {userRole === 'admin' ? 'Task & Performance Tracker' : 'My Tasks'}
        </h1>
        <div className="topbar-user-section">
          {userRole === 'member' && (
            <div className="user-selector-container">
              <button
                className="user-selector-btn"
                onClick={() => setShowUserSelector(!showUserSelector)}
              >
                <FiUser className="user-icon" />
                <span className="selected-user-name">{selectedUserName || 'All Tasks'}</span>
                <span className="user-selector-arrow">▼</span>
              </button>
              {showUserSelector && (
                <div className="user-selector-dropdown">
                  <div className="user-selector-header">Select Your Name</div>
                  <button
                    className={`user-option ${!selectedUserName ? 'active' : ''}`}
                    onClick={() => handleUserChange('')}
                  >
                    All Tasks
                  </button>
                  {users.map(user => (
                    <button
                      key={user.id}
                      className={`user-option ${selectedUserName === user.name ? 'active' : ''}`}
                      onClick={() => handleUserChange(user.name)}
                    >
                      {user.name}
                      {user.role === 'admin' && <span className="admin-badge">Admin</span>}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
          <span className="user-role">{userRole === 'admin' ? 'Admin' : 'Team Member'}</span>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
